import { render, staticRenderFns } from "./impressum.vue?vue&type=template&id=298f4899&scoped=true&"
import script from "./impressum.vue?vue&type=script&lang=js&"
export * from "./impressum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f4899",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Ampps/www/passwort-generator-pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VContainer,VDivider,VFlex,VLayout,VProgressLinear})
